import { uuid } from '@spazious/dollhouse-utils';

export const getSession = () => {
  return uuid();
};

export default getSession;
